<mat-button-toggle-group
  class="procedure-content-view-selector"
  hideSingleSelectionIndicator
  [value]="currentProcedureContentViewName"
  [attr.aria-label]="'TRANS__FIELD__FIELD_DISPLAY' | translate"
  (change)="selectView($event.value)"
>
  @for (view of views; track view.name) {
    <mat-button-toggle
      class="procedure-content-view-selector__segment"
      [value]="view.name"
    >
      {{ view.labelKey | translate }}
    </mat-button-toggle>
  }
</mat-button-toggle-group>
